export default __webpack_public_path__ + "static/media/faq_banner.28e84c44.png";